import sendGoogleAnalytics, {
  GAEventInterface,
} from '../../sendGoogleAnalytics';

const eventCategory = `${process.env.BRAND_IDENTIFIER}:catalogo-virtual`;

export enum ZoomInAction {
  buttonClick = 'clique:botao-aumentar-zoom',
  pageClick = 'clique:pagina',
  doubleTap = 'double-tap',
  pinch = 'pinch',
}

const zoomIn = (
  zoomInAction: ZoomInAction,
  zoomScale?: GAEventInterface['eventValue'],
) => {
  const data: GAEventInterface = {
    eventCategory,
    eventAction: zoomInAction,
    eventLabel: 'zoom-in',
  };

  if (zoomScale) {
    data['eventValue'] = zoomScale;
  }

  sendGoogleAnalytics.event(data);
};

export enum ZoomOutAction {
  closeButtonClick = 'clique:botao-fechar',
  zoomOutButtonClick = 'clique:botao-diminuir-zoom',
  pageClick = 'clique:pagina',
  keyDownEsc = 'tecla:esc',
  doubleTap = 'double-tap',
  pinch = 'pinch',
}

const zoomOut = (
  zoomOutAction: ZoomOutAction,
  zoomScale?: GAEventInterface['eventValue'],
) => {
  const data: GAEventInterface = {
    eventCategory,
    eventAction: zoomOutAction,
    eventLabel: 'zoom-out',
  };

  if (zoomScale) {
    data['eventValue'] = zoomScale;
  }

  sendGoogleAnalytics.event(data);
};

export enum NavigationAction {
  swipe = 'swipe',
  tap = 'tap',
  sliderButtonClick = 'clique:botao-slider',
}

const navigationPrev = (eventAction: NavigationAction) => {
  sendGoogleAnalytics.event({
    eventCategory,
    eventAction,
    eventLabel: 'pagina-anterior',
  });
};

const navigationNext = (eventAction: NavigationAction) => {
  sendGoogleAnalytics.event({
    eventCategory,
    eventAction,
    eventLabel: 'pagina-seguinte',
  });
};

const openProductList = () => {
  sendGoogleAnalytics.event({
    eventCategory,
    eventAction: 'clique:botao',
    eventLabel: 'abrir-lista-produtos',
  });
};

const closeProductList = () => {
  sendGoogleAnalytics.event({
    eventCategory,
    eventAction: 'clique:botao',
    eventLabel: 'fechar-lista-produtos',
  });
};

export const sendCatalogEvent = {
  buttonClickZoomIn: () => zoomIn(ZoomInAction.buttonClick),
  pageClickZoomIn: () => zoomIn(ZoomInAction.pageClick),
  doubleTapZoomIn: () => zoomIn(ZoomInAction.doubleTap),
  pinchZoomIn: (zoomScale: GAEventInterface['eventValue']) =>
    zoomIn(ZoomInAction.pinch, zoomScale),

  closeButtonClickZoomOut: () => zoomOut(ZoomOutAction.closeButtonClick),
  buttonClickZoomOut: () => zoomOut(ZoomOutAction.zoomOutButtonClick),
  pageClickZoomOut: () => zoomOut(ZoomOutAction.pageClick),
  keyDownEscZoomOut: () => zoomOut(ZoomOutAction.keyDownEsc),
  doubleTapZoomOut: () => zoomOut(ZoomOutAction.doubleTap),
  pinchZoomOut: (zoomScale: GAEventInterface['eventValue']) =>
    zoomOut(ZoomOutAction.pinch, zoomScale),

  swipeNavigationPrev: () => navigationPrev(NavigationAction.swipe),
  tapNavigationPrev: () => navigationPrev(NavigationAction.tap),
  buttonClickPrev: () => navigationPrev(NavigationAction.sliderButtonClick),

  swipeNavigationNext: () => navigationNext(NavigationAction.swipe),
  tapNavigationNext: () => navigationNext(NavigationAction.tap),
  buttonClickNext: () => navigationNext(NavigationAction.sliderButtonClick),

  openProductList,
  closeProductList,
};
